/*
 * @Author: zhouwei
 * @Date: 2019-10-30 22:18:12
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-05 15:40:02
 * @Desc: 选择营销资料
*/
<template>
  <mk-drawer
    :visible.sync="show"
    class="material"
    size="800px"
    hide-header
    :before-close="cancel"
  >
    <div class="material-content">
      <div class="material-content-h">
        <h3>{{ state === 0 ? '新增任务' : '更新任务' }}</h3>
        <i
          class="close iconfont icon-mk-guanbi"
          @click="cancel"
        ></i>
      </div>
      <div class="material-con-tit">
        <div class="tit">
          <span class="icon"></span>
          基本信息
        </div>
        <div class="con">
          <div>
            <span class="icon">*</span>
            执行时间
          </div>
          <div class="box">
            <mk-date-picker
              v-model="taskStartDate"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="pickerOptions"
              @change="changeDate"
            >
            </mk-date-picker>
            <span style="    display: block; color: #8c8c8c; font-size: 12px;">*任务的执行时间，需要在计划时间之内</span>
          </div>
        </div>
      </div>
      <div class="material-con-type">
        <div class="tit">
          <span class="icon"></span>
          资料类型
        </div>
        <div class="con">
          <div class="btn-group">
            <span
              v-for="(item,index) in meansInfo.originType"
              :key="index"
              class="btn-item-type"
              :class="item.active ? 'active' : ''"
              @click="originTypeChangeC(index)"
            >
              {{ item.name }}
            </span>
          </div>
          <div class="search">
            <mk-input
              v-model="titValue"
              :placeholder="meansInfoDefault"
              class="int"
              maxlength="20"
              clearable
            ></mk-input>
            <tag-select-cascader
              v-model="levelTags"
              width="320"
              class="tag"
              @change="tagChange"
            />
            <!-- <mk-select
              v-model="tagValue"
              multiple
              collapse-tags
              placeholder="标签(多选)"
              width="188"
              class="tag"
            >
              <mk-option-group
                v-for="(group,groupIndex) in tags"
                :key="groupIndex"
                :label="group.label"
              >
                <mk-option
                  v-for="(item,itemIndex) in group.options"
                  :key="itemIndex"
                  :label="item.label"
                  :value="item.value"
                >
                </mk-option>
              </mk-option-group>
            </mk-select> -->
            <mk-button-biz
              type="primary"
              icon="el-icon-search"
              @click="search"
            >
              搜索
            </mk-button-biz>
            <mk-button-biz @click="reset">
              重置
            </mk-button-biz>
          </div>
          <div class="list">
            <mk-table
              :data="list"
              height="100%"
            >
              <mk-table-column
                prop="title"
                :label="meansInfoTitle"
                width="300"
              >
                <template v-slot="scope">
                  <mk-checkbox
                    v-model="scope.row.checked"
                    @change="listChange(scope.$index, scope.row.checked,scope)"
                  ></mk-checkbox>
                  <span class="list-title">{{ scope.row.title }}</span>
                </template>
              </mk-table-column>
              <mk-table-column
                prop="tag"
                label="标签"
              >
                <template v-slot="scope">
                  <tag-list-show-new
                    :tag-list="scope.row.tag"
                    :limit="3"
                  />
                </template>
              </mk-table-column>
              <mk-table-column
                prop="time"
                label="更新时间"
                width="200"
              >
              </mk-table-column>
            </mk-table>
          </div>
          <mk-pagination
            :current-page.sync="taskPage"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="taskTotal"
            class="pagination"
            @current-change="handleCurrentChange"
          >
          </mk-pagination>
        </div>
      </div>
      <div class="handle-list-data">
        <span class="txt">已选中&nbsp;{{ meansInfo.str }}</span>
        <div class="group">
          <mk-button-biz @click="cancel">
            取消
          </mk-button-biz>
          <mk-button-biz
            type="primary"
            @click="addMaketingData(state)"
          >
            {{ state === 0 ? '添加': '更新' }}
          </mk-button-biz>
        </div>
      </div>
    </div>
  </mk-drawer>
</template>
<script>
import dayjs from 'dayjs'
import TagSelectCascader from '@components/tag-select-cascader'
import tagListShowNew from '@components/tag-list-show-new'
let that
export default {
  components: {
    TagSelectCascader,
    tagListShowNew
  },
  props: {
    show: {
      type: Boolean,
      defalut: false
    },
    // eslint-disable-next-line vue/require-default-prop
    state: {
      type: Number,
      defalut: 0
    },
    // eslint-disable-next-line vue/require-default-prop
    date: {
      // 初始化日历(只在编辑时生效)
      type: [String, Array, Object],
      defalut () {
        return []
      }
    },
    startDate: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/require-default-prop
    initType: {
      // 初始化资料类型(只在编辑时生效)
      type: String,
      defalut: ''
    },
    // eslint-disable-next-line vue/require-default-prop
    selectedId: {
      type: String,
      defalut: ''
    }
  },
  data () {
    return {
      taskStartDate: '',
      meansInfoTitle: '文章标题', // 子任务选择标题
      meansInfoDefault: '请输入文章标题',
      meansInfo: {
        // 营销资料
        originType: [
          {
            name: '文章',
            active: true
          },
          {
            name: '朋友圈',
            active: false
          },
          {
            name: '表单',
            active: false
          }
        ],
        str: '' // 列表选择的title字符
      },
      originTypeIndex: 0, // nav索引
      titValue: '', // 标题
      tagValue: [], // 标签的value值
      tags: [], // 标签集合
      list: [], // 列表
      taskPage: 1, // 页数
      taskTotal: 0,
      selectedInfo: {
        row: {}
      },
      pickerOptions: {
        disabledDate: time => {
          let minTime = new Date(that.date[0]).getTime()
          let maxTime = new Date(that.date[1]).getTime()
          return time.getTime() <= minTime - 24 * 60 * 60 * 1000 || time.getTime() > maxTime
        }
      },
      levelTags: [] // 二级标签选择值
    }
  },
  created () {
    that = this
    let obj = {
      article: 0,
      friend: 1,
      form: 2
    }
    // this.getTags()
    if (!this.state) {
      this.getArticleList()
    } else {
      this.taskStartDate = new Date(this.startDate)
      this.originTypeChange(obj[this.initType])
    }
  },
  methods: {
    /**
     * * 标签change事件
     */
    tagChange () {
      this.tagValue = this.util.levelTagsToTags(this.levelTags)
    },
    changeDate (data) {
      if (this.date instanceof Array) {
        if (new Date(data).getTime() < new Date(this.date[0]).getTime()) {
          this.taskStartDate = this.date[0]
        } else if (new Date(data).getTime() > new Date(this.date[1]).getTime()) {
          this.taskStartDate = this.date[1]
        }
      }
    },
    // 获取标签
    // async getTags () {
    //   const res = await BIZAPIS.TagApi.tagEnableGet({})
    //   if (res.success) {
    //     let arr = []
    //     res.data.forEach((item, index) => {
    //       let obj = {
    //         label: item.name,
    //         id: item.id,
    //         options: []
    //       }
    //       if (item.children && item.children.length > 0) {
    //         item.children.forEach((itemC, indexC) => {
    //           obj.options[indexC] = {
    //             label: itemC.name,
    //             value: itemC.id,
    //             id: itemC.id
    //           }
    //         })
    //       }
    //       arr[index] = obj
    //     })
    //     this.tags = arr
    //   }
    // },
    getMeta (type) {
      let metas = {
        title: this.titValue,
        tags: this.tagValue,
        status: 1,
        showTags: true,
        page: this.taskPage
      }
      if (type === 'search') {
        if (this.tagValue === '' || this.tagValue === undefined) {
          delete metas['tags']
        }
        if (this.titleVal === '' || this.titValue === undefined) {
          delete metas['title']
        }
      } else {
        delete metas['tags']
        delete metas['title']
      }
      return metas
    },
    handleListData (res) {
      // 处理列表数据
      let data = res.data
      this.taskTotal = res.total
      let arr = []
      data.forEach((item, index) => {
        arr[index] = {
          title: item.title,
          tag: item.showTags,
          time: item.updateTime,
          checked: false,
          id: item._id
        }
        if (this.state === 1) {
          if (item._id === this.selectedId) {
            arr[index] = {
              title: item.title,
              tag: item.showTags,
              time: item.updateTime,
              checked: true,
              id: item._id,
              disabled: true
            }
            this.selectedInfo.row = arr[index]
            this.meansInfo.str = arr[index].title
          }
        }
      })
      this.list = arr
    },
    cancel () {
      // 取消事件
      this.$emit('cancel')
      this.clear()
    },
    originTypeChangeC  (index) {
      this.taskPage = 1
      this.originTypeChange(index)
    },
    originTypeChange (index, type) {
      this.meansInfo.originType.forEach((item, indexC) => {
        if (index === indexC) {
          item.active = true
        } else {
          item.active = false
        }
      })
      this.originTypeIndex = index
      if (index === 0) {
        this.meansInfoTitle = '文章标题'
        this.meansInfoDefault = '请输入文章标题'
      } else if (index === 1) {
        this.meansInfoTitle = '名称'
        this.meansInfoDefault = '请输入朋友圈名称'
      } else if (index === 2) {
        this.meansInfoTitle = '表单名称'
        this.meansInfoDefault = '请输入表单名称'
      }
      if (index === 0) {
        this.getArticleList(type)
      } else if (index === 1) {
        this.getFriendList(type)
      } else {
        this.getFormList(type)
      }
    },
    handleCurrentChange (e) {
      // 分页器变化
      this.taskPage = e
      this.originTypeChange(this.originTypeIndex)
    },
    async getArticleList (type) {
      this.list = []
      let metas = this.getMeta(type)
      // 获取文章列表
      const res = await BIZAPIS.MaterialArticleApi.materialArticleIndexPost(
        metas
      )
      if (res.success) {
        this.handleListData(res.data)
      }
    },
    async getFriendList (type) {
      // 获取朋友圈列表
      this.list = []
      let metas = this.getMeta(type)
      const res = await BIZAPIS.MaterialCircleFriendsApi.materialCircleFriendsIndexPost(
        metas
      )
      if (res && res.success) {
        this.handleListData(res.data)
      }
    },
    async getFormList (type) {
      // 获取表单列表
      this.list = []
      let metas = this.getMeta(type)
      const res = await BIZAPIS.FormApi.materialFormIndexPost(metas)
      if (res && res.success) {
        this.handleListData(res.data)
      }
    },
    search () {
      // 搜索
      if (this.originTypeIndex === 0) {
        this.getArticleList('search')
      } else if (this.originTypeIndex === 1) {
        this.getFriendList('search')
      } else {
        this.getFormList('search')
      }
    },
    reset () {
      this.titValue = ''
      this.tagValue = ''
      this.levelTags = []
      this.search()
    },
    clear () {
      // 退出页面清空已填项
      this.meansInfo.str = ''
      this.selectedInfo = {}
      this.tagValue = ''
      this.titValue = ''
      this.taskStartDate = null
      this.list = []
    },
    listChange (indexC, state, data) {
      if (state) {
        this.selectedInfo = data
        this.list.forEach((item, index) => {
          if (index === indexC) {
            this.meansInfo.str = item.title
          } else {
            this.list[index].checked = false
          }
        })
      } else {
        this.meansInfo.str = ''
        this.selectedInfo = {}
      }
    },
    addMaketingData (e) {
      if (this.taskStartDate && this.date instanceof Array) {
        if (
          new Date(this.taskStartDate).getTime() >= new Date(this.date[0]).getTime() &&
          new Date(this.taskStartDate).getTime() <= new Date(this.date[1]).getTime()
        ) {
          if (
            this.selectedInfo &&
            this.selectedInfo.row &&
            this.selectedInfo.row.id
          ) {
            let materialType
            if (this.originTypeIndex === 0) {
              materialType = 'article'
            } else if (this.originTypeIndex === 1) {
              materialType = 'friend'
            } else {
              materialType = 'form'
            }
            let result = {
              execTime: dayjs(this.taskStartDate).format('YYYY-MM-DD HH:mm'),
              materialId: this.selectedInfo.row.id,
              materialType: materialType,
              showName: this.selectedInfo.row.title,
              showTags: this.selectedInfo.row.tag
            }
            if (e === 0) {
              this.$emit('add', result)
              this.clear()
              this.$emit('cancel')
            } else {
              this.$emit('replace', result)
              this.clear()
              this.$emit('cancel')
            }
          } else {
            this.$message({
              type: 'error',
              message: '请选择营销资料'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: '请选择计划执行时间之内的时间',
            showClose: true
          })
        }
      } else {
        this.$message({
          type: 'error',
          message: '请选择执行时间',
          showClose: true
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.material {
  /deep/ .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 173px;
    height: 32px;
  }

  /deep/ .el-input__inner {
    height: 30px;
  }

  /deep/ .el-input__icon {
    line-height: 24px;
  }

  // /deep/ .mk-select .el-input__inner {
  //   height: 32px !important;
  // }

  .material-content {
    width: 800px;
    height: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    background: #fff;
    position: relative;

    .material-content-h {
      line-height: 48px;
      border-bottom: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      h3 {
        font-weight: normal;
        font-size: 16px;
      }

      .close {
        font-size: 16px;
        cursor: pointer;
      }
    }

    .material-con-tit {
      margin-top: 16px;

      .tit {
        line-height: 20px;
        font-weight: 500;
        display: flex;

        .icon {
          display: inline-block;
          width: 6px;
          height: 20px;
          background: #009cff;
          margin-right: 12px;
          line-height: 20px;
        }
      }

      .con {
        display: flex;
        margin: 16px 24px;
        font-size: 13px;
        color: #8e8e8e;
        line-height: 32px;

        i {
          font-size: 16px;
        }

        span {
          color: red;
        }

        .box {
          line-height: 32px;
          margin-left: 16px;
        }
      }
    }

    .material-con-type {
      .tit {
        line-height: 20px;
        font-weight: 500;
        display: flex;

        .icon {
          display: inline-block;
          width: 6px;
          height: 20px;
          background: #009cff;
          margin-right: 12px;
          line-height: 20px;
        }
      }

      .con {
        .btn-group {
          display: flex;
          margin-top: 24px;

          .btn-item-type {
            display: block;
            width: 88px;
            height: 32px;
            box-sizing: border-box;
            border: 1px solid #e8e8e8;
            text-align: center;
            line-height: 32px;
            font-size: 13px;
            border-radius: 4px;
            margin-right: 16px;
            cursor: pointer;
          }

          .btn-item-type.active {
            color: #fff;
            background: #009cff;
            border-bottom: #009cff;
          }
        }

        .tag-group {
          display: flex;

          .tag-group-item {
            display: flex;

            .tag-item {
              display: block;
              margin-right: 4px;
              padding: 0 8px;
              font-size: 12px;
              height: 22px;
              line-height: 22px;
              background-color: #ebeff4;
              color: #6b7b88;
            }

            .tag-info {
              line-height: 22px;
              margin-left: 4px;
              font-size: 14px;
            }
          }
        }

        .search {
          display: flex;
          margin-top: 24px;

          .int {
            width: 188px;
            margin-right: 12px;
          }

          .select {
            margin-right: 32px;
          }

          .tag {
            margin-right: 12px;
          }
        }

        .list {
          margin-top: 24px;
          height: calc(100vh - 435px);
          overflow-y: auto;

          .list-title {
            margin-left: 8px;
          }
        }
      }
    }

    .handle-list-data {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      border-top: 1px solid #e8e8e8;
      background: #fff;
      z-index: 99;

      .txt {
        font-size: 13px;
        color: #595959;
        max-width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }
}
</style>
<style lang="scss">
  .tag-popper {
    min-width: unset;
    padding: 10px 0 0 10px;

    .tag-item-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 145px;
      max-height: 300px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 5px;
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: rgba(193, 193, 193, 0.8);
      }

      .tag-item {
        height: 22px;
        padding: 0 8px;
        margin-right: 10px;
        margin-bottom: 10px;
        line-height: 22px;
        background-color: #ebeff4;
        color: #6b7b88;
        border-radius: 2px;
        font-size: 12px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>
